import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    conditionBuilderContainer: {
      display: 'flex',
      gap: '16px',
      marginTop: theme.spacing(2),
    },
    conditionType: {
      minWidth: '195px',
      '& p': {
        '& p::after': {
          content: "'*'",
          color: theme.palette.common.red400,
          margin: theme.spacing(0.5),
        },
      },
    },
    conditionValue: {
      position: 'relative',
      flexGrow: 1,
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        '& > div:nth-child(2)': {
          position: 'inherit',
          width: '100%',
          marginTop: 'auto',
        },
        '& > div': {
          width: '100%',
          marginTop: theme.spacing(0.5),
        },
        // Pill and caret layout for the closed button only. The open option
        // panel is the second child and keeps its own SearchInput layout.
        '& > div:first-child': {
          '& > div': {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            paddingRight: theme.spacing(5),
            '& > div': {
              borderRadius: '3px',
              margin: theme.spacing(0.25, 0.75),
              zIndex: 100,
              padding: '2px 8px 2px 10px',
              minHeight: '28px',
              alignContent: 'center',
              '& > p': {
                fontSize: '14px',
              },
            },
            '& > div:last-child': {
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              right: '15px',
            },
          },
        },
      },
    },
    nestedRequired: {
      '&::after': {
        content: "'*'",
        color: theme.palette.common.red400,
        margin: theme.spacing(0.5),
      },
    },
    trashIcon: {
      alignSelf: 'center',
      fontSize: '14px',
      position: 'absolute',
    },
    trashIconDisabled: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      opacity: 0.5,
    },
    trashIconContainer: {
      marginTop: theme.spacing(4.25),
      cursor: 'pointer',
    },
    separator: {
      width: 'max-content',
      fontWeight: 700,
      marginTop: theme.spacing(2),
      padding: theme.spacing(0.5, 1),
      background: theme.palette.common.gray100,
      fontSize: '12px',
      borderRadius: '5px',
      color: theme.palette.common.black,
    },
    isAnyOfText: {
      alignItems: 'center',
      display: 'flex',
      height: '50px',
      marginTop: theme.spacing(2),
      minWidth: '53px',
    },
    tooltipIcon: {
      margin: theme.spacing(0, 0, 0, 1),
    },
  }),
);
